<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <path
            :fill="customColor"
            d="M15.01 0h-5.5a.987.987 0 0 0 0 1.972h3.12L7.425 7.176a.979.979 0 0 0-.289.697c0 .264.103.511.29.697a.979.979 0 0 0 .696.29.98.98 0 0 0 .698-.29l5.204-5.204v3.12a.987.987 0 0 0 1.972 0v-5.5A.987.987 0 0 0 15.01 0z"
        />
        <path
            :fill="customColor"
            d="M11.332 14.305H1.69V4.664h7.251l1.69-1.69H.846A.845.845 0 0 0 0 3.819V15.15c0 .466.378.845.845.845h11.332a.845.845 0 0 0 .845-.845V5.364l-1.69 1.69v7.251z"
        />
    </svg>
</template>

<script setup>
    import { DEFAULT_BUTTON_COLOR } from '~/utils/constants';

    defineProps({
        customColor: {
            type: String,
            required: false,
            default: DEFAULT_BUTTON_COLOR
        }
    });
</script>
